import React from 'react';
// @ts-ignore
import HeroImage from '../../assets/zaffloBG.png';
// @ts-ignore
import LogoImage from '../../assets/fav.png';
import { useNavigate } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';

const Hero = () => {
  const navigate = useNavigate();
  const currentRole = localStorage.getItem("role");
  const hasEmail = localStorage.getItem("user");

  const navigateToLogin = () => {
    if (!!currentRole && !!hasEmail) {
      navigate(currentRole === 'admin' ? "/admin" : "/user");
      return;
    }
    navigate('/login', { replace: true });
  };

  return (
    <section className="bg-white py-24 relative overflow-hidden">
      
     {/* 🎉 3 Months Free Trial Badge - Center Top */}
<div className="absolute top-5 left-1/2 transform -translate-x-1/2 z-20">
  <div className="bg-gradient-to-br from-purple-500 to-pink-500 text-white px-4 py-1 rounded-full text-xs font-bold shadow-xl animate-bounce">
    🎉 3 Months Free Trial!
  </div>
</div>

    

      {/* 🔥 Main Content - Container Centering */}
      <div className="container mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center z-10">
        
        <div className="md:w-1/2 relative">
          {/* 🟢 Logo - Top Left with margin for better alignment */}
      <div className=" top-8 left-0 z-20">
        <img src={LogoImage} alt="zafflo Logo" className="h-14 w-auto" />
      </div>

          <h1 className="text-4xl font-bold text-gray-800 mt-16 mb-4 leading-tight">
            Behind every <strong className="text-[#6cbb23] hover:text-green-700 transition duration-300">DIGITAL MENU</strong> there is{' '}
            <strong className="text-[#6cbb23] hover:text-green-700 transition duration-300">ZAFFLO</strong>
          </h1>

          <p className="text-base text-gray-600 mb-6">
            Increase your Revenue, Repeat Customers, Digital Presence, Google Ratings and much more...
          </p>

          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => document.getElementById('BookDemo')?.scrollIntoView({ behavior: 'smooth' })}
              className="inline-flex items-center px-6 py-2 border-2 border-[#6cbb23] text-[#6cbb23] hover:bg-[#6cbb23] hover:text-white rounded-full transition duration-300"
            >
              <FaWhatsapp className="mr-2" /> Book Free Demo
            </button>

            <button
              onClick={navigateToLogin}
              className="px-6 py-2 border-2 border-[#6cbb23] text-[#6cbb23] hover:bg-[#6cbb23] hover:text-white rounded-full transition duration-300"
            >
              {!!currentRole ? 'Go to your dashboard' : 'Login'}
            </button>
          </div>
        </div>

        <div className="md:w-1/2 mt-10 md:mt-0 z-10">
          <img
            src={HeroImage}
            alt="zafflo hero image"
            className="w-full max-w-md mx-auto animate-slide-in-right"
          />
        </div>
      </div>

      {/* 🌍 Tagline - Below Hero */}
      <div className="mt-10 text-center z-30 relative">
        <div className="inline-block bg-gradient-to-r from-green-200 via-[#6cbb23] to-green-400 text-black px-6 py-2 rounded-full shadow-md text-sm md:text-base font-semibold tracking-wide uppercase">
          Digitise your menu in all Indian languages
        </div>
      </div>
    </section>
  );
};

export default Hero;
